import 'core-js/modules/es.array.map';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import Globalize from '@paypalcorp/globalize/dist/globalize';
import { isPlainObject } from 'is-plain-object';
import { assertType, assert } from 'yaassertion';

/**
 * Given a locale, it  will return certain old locales to new form
 * @param {locale} locale to replace
 * @return {new_locale}
 */
function normalizeLocale(locale) {
  // prettier-ignore
  return locale.replace(/\bno\b/, "nb").replace(/\btl\b/, "fil");
}

/**
 * Function that normalizes locale according to paypal standards. It performs the following operations on locale:
 * 1) replaces '_' with '-' in locale string. E.g., 'en_US' will be replaced with 'en-US'
 * 2) replaces 'C2' with 'CN-xbord'. E.g., 'en-C2' will be 'en-CN-xbord'
 * 3) replaces no with nb
 * 4) replaces tl with fil. E.g., 'tl-PH' will be replaced to 'fil-PH'
 * @param {String} locale bcp-47 locale value (en-US, fr-FR, etc)
 * @param {Object} options an object that can take prop named langSubtag
 * @returns {String} normalized locale value
 */
function _normalizeLocale(locale, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$langSubtag = _ref.langSubtag,
    langSubtag = _ref$langSubtag === void 0 ? true : _ref$langSubtag;
  if (locale.payPalLocaleCode) {
    // A payPalLocaleCode to existing limited locale support.
    var _locale$payPalLocaleC = locale.payPalLocaleCode,
      _locale = _locale$payPalLocaleC.locale,
      _country = _locale$payPalLocaleC.country;
    var _locale$split = _locale.split(/[-_]/),
      _localeLanguage = _locale$split[0];
    locale = _localeLanguage + "-" + _country;

    // A payPalLocaleCode to standard locale normalization: (when PayPal supports all locales anywhere)
    // const { locale: _locale } = locale.payPalLocaleCode;
    // const [_localeLanguage, _localeCountry] = _locale.split(/[-_]/);
    // if (_localeCountry === "XC") {
    //   if (_localeLanguage === "es") {
    //     // es_XC -> es-MX
    //     locale = "es-MX";
    //   } else {
    //     // fr_XC -> fr
    //     // zh_XC -> zh
    //     locale = _localeLanguage;
    //   }
    // } else {
    //   locale = _locale;
    // }
  }
  if (process.env.NODE_ENV !== "production") {
    assert(typeof locale === "string", typeof locale === "object" ? "Invalid locale {{locale}}. Did you mean {{didYouMean}}?" : "Invalid locale {{locale}}", {
      locale: locale,
      didYouMean: {
        payPalLocaleCode: locale
      }
    });
  }
  locale = locale
  // Support both _ & - as locale separator.
  // Note: This must precede other replaces using `\b`.
  .replace(/_/, "-")
  // If locale includes C2, replace it with CN-xbord
  .replace(/\bC2\b/, "CN-xbord");
  if (langSubtag) {
    locale = normalizeLocale(locale);
  }
  return locale;
}
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}
var DOCUMENTATION_HOMEPAGE = "https://github.paypal.com/pages/Globalization-R/worldready-js/docs";

// Internationalization and localization data providers array:
var isWorldReadyLoadCalled;
var isWorldReadyInstance = function isWorldReadyInstance(object) {
  return object && object.globalize;
};

/**
 * Region
 */
var Region = /*#__PURE__*/function () {
  function Region() {}
  Region.getRegionString = function getRegionString(worldReadyOrRegionOrString) {
    if (worldReadyOrRegionOrString && worldReadyOrRegionOrString.region) {
      return getResolvedRegion(worldReadyOrRegionOrString.region);
    }
    return getResolvedRegion(worldReadyOrRegionOrString);
  };
  return Region;
}();
if (process.env.NODE_ENV !== "production") {
  Region.assertType = function (parameterValue, parameterName) {
    assertType(parameterValue, parameterName, ["string", "object"]);
  };
}

/**
 * WorldReady
 */
var WorldReady = function WorldReady(locale) {
  var _main;
  if (process.env.NODE_ENV !== "production") {
    assert(isWorldReadyLoadCalled, "Load WorldReady metadata first. Please read " + DOCUMENTATION_HOMEPAGE + "/about-load-worldready-data.html");
  }
  if (!(this instanceof WorldReady)) {
    return new WorldReady(locale);
  }

  // TODO assert locale
  locale = _normalizeLocale(locale);

  // Hack: set any locale as available locale.
  Globalize.load({
    main: (_main = {}, _main[locale] = {}, _main)
  });
  this.globalize = new Globalize(locale);
  var cldr = this.globalize.cldr;
  this.bundle = cldr.attributes.bundle;
  this.locale = cldr.locale;
  this.language = cldr.attributes.language;
  this.region = cldr.attributes.region;
  this.market = this.region;
  this.weekInfo = {
    minDays: cldr.get(["supplemental/weekData/minDays", this.region]) || cldr.get("supplemental/weekData/minDays/001"),
    firstDay: cldr.get(["supplemental/weekData/firstDay", this.region]) || cldr.get("supplemental/weekData/firstDay/001"),
    weekendStart: cldr.get(["supplemental/weekData/weekendStart", this.region]) || cldr.get("supplemental/weekData/weekendStart/001"),
    weekendEnd: cldr.get(["supplemental/weekData/weekendEnd", this.region]) || cldr.get("supplemental/weekData/weekendEnd/001")
  };
  this.metadata = cldr.get(["metadata"]) || {};
};

/**
 * async WorldReady.load()
 */
{
  // Client-side
  WorldReady.load = function () {
    // TODO assert params
    isWorldReadyLoadCalled = true;
    for (var _len = arguments.length, providers = new Array(_len), _key = 0; _key < _len; _key++) {
      providers[_key] = arguments[_key];
    }
    providers.map(function (provider) {
      if (isPlainObject(provider)) {
        Globalize.load(provider);
        return;
      }
      throw new Error("Oops: Async provider not supported in browsers at the moment");
    });
  };
}
WorldReady._Globalize = Globalize;

/**
 * WorldReady features skeleton
 */
if (process.env.NODE_ENV !== "production") {
  var loadError = function loadError(feature) {
    return function () {
      throw new Error("Missing feature, you may want to `import @paypalcorp/worldready-" + feature + "`");
    };
  };
  WorldReady.prototype.Address = loadError("address");
  WorldReady.prototype.RelativeTimeFormat = loadError("relative-time");
  WorldReady.prototype.MessageFormat = loadError("message");
  WorldReady.prototype.NumberFormat = loadError("number");
  WorldReady.prototype.CurrencyFormat = loadError("currency");
}
var Griffin = WorldReady;

export { Griffin, Region, WorldReady, isWorldReadyInstance };
